// TODO
//
// bugsnagやlogtailのログでユーザー名を使いたいが、都度ユーザー情報を引数で渡す形のは面倒くさい
// 堅牢ではないが、ユーザー情報をlocalStorageに入れてしまい、それを使い回す形にする
//
import { z } from 'zod'

import { CONSTANT } from '../config/constant'

const userInfoSchema = z.object({
  email: z.string(),
  id: z.string(),
  name: z.string(),
  tenant: z.object({
    id: z.string(),
    name: z.string(),
  }),
})
export type LocalStorageUserInfo = z.infer<typeof userInfoSchema>

export function getUserInfoFromLocalStorage() {
  try {
    const cache = localStorage.getItem(CONSTANT.localStorageKey.USER_INFO_FOR_LOG)
    if (cache === null) {
      return undefined
    }
    const auth0User = JSON.parse(cache) as unknown
    return userInfoSchema.parse(auth0User)
  } catch (e) {
    return undefined
  }
}

export function setUserInfoToLocalStorage(user: LocalStorageUserInfo) {
  const userInfo = userInfoSchema.parse(user)
  localStorage.setItem(CONSTANT.localStorageKey.USER_INFO_FOR_LOG, JSON.stringify(userInfo))
}
